import React, { useRef, useState } from "react";
import {
  Box,
  Button,
  Divider,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  Stack,
  Tab,
  Tabs,
  TextField,
  Typography,
} from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import SearchIcon from "@mui/icons-material/Search";
import DownloadIcon from "@mui/icons-material/Download";

import "react-datepicker/dist/react-datepicker.css";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { getCounterSalesStatement } from "./outstandingApi";
import { useEffect } from "react";

import DisplayOutStandingReport from "./displayOutStandingReport";
import OutStandingReportCart from "./outStandingReportCart";

import { downloadXLSXFile } from "../../utils/commonUtils";
import { api } from "../../utils/api";
import { getCounterSales } from "./outStandingReportCustomApiHandler";
import { displayOutstading } from "./outstandingReportFunction";
import PaymentReceiptSearchModal from "../paymentReceipt/paymentReceiptSearchModal";
import { getUnpaidUser } from "../paymentReceipt/paymentReceiptApi";
import PaymentReceipt from "../paymentReceipt/paymentReceipt";
import DynamicBreadcrumbs from "../../common/Breadcrumb";
import { useSelector } from "react-redux";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import Heading from "../../common/Heading";
const OutstandingReport = () => {
  const businessChooseTab = useSelector(
    (state) => state.reducer.businessChooseTab
  );

  const [modalData, setModalData] = useState();
  const [outStandingBills, setOutStandingBills] = useState({
    records: [],
    totalOustandingAmount: "",
    totalRecords: "",
  });
  const [value, setValue] = React.useState("outstanding");

  const tabfn = (event, newValue) => {
    // setPageNo(1);

    setValue(newValue);
  };
  const [selectedUser, setSelectedUser] = useState({
    name: "",
    mobile: "",
  });

  const [open, setOpen] = useState(false);
  //-----
  const [searchOutStandingsModal, setSearchOutStandingsModal] = useState(false);
  const [upPaidBillData, setUnPaidBillData] = useState();
  const [unPaidBill, setUnPaidBill] = useState([]);
  const data = {
    customerMobile: "",
    amount: 0,
    name: "",
  };
  const [billData, setBillData] = useState(data);
  const [billFilter, setBillFilter] = useState(null);

  const getUnpaid = async (param) => {
    await getUnpaidUser(param)
      .then((res) => {
        console.log("unPaid user", res?.data?.data[0]);

        setUnPaidBillData(res?.data?.data[0]);
      })
      .catch((err) => {});
  };
  //----
  const filters = [
    { name: "Amount Greater than ", value: "amountgreatethan" },
    { name: "Amount Less than ", value: "amountlessthan" },
    { name: "Amount elapsed than ", value: "dayselapsed" },
    { name: "Partially Paid ", value: "partlypaid" },
  ];

  ///---pagination functions
  const [pagination, setPagination] = useState({
    page: 1,
    total: 1,
    records: 0,
    pageSize: 24,
  });
  const [payloadGetCounterSales, setPayloadGetCounterSales] = useState({
    page: 1,
    pageSize: pagination.pageSize,
    sortBy: "",
    order: 0,
    buyerGroupId: 0,
    filter: "",
    search: "",
  });
  const [numberOfRecords, setNumberOfRecords] = useState(1);
  const handleChange = (event, value) => {
    getCounterSales(
      {
        ...payloadGetCounterSales,
        page: value,
        pageSize: pagination.pageSize,
      },
      outStandingBills,
      getCounterSalesStatement,
      setNumberOfRecords,
      setOutStandingBills
    );
    setPagination({
      ...pagination,
      page: value,
    });
  };

  const [search, setSearch] = useState("");

  // const [value, setValue] = useState("");
  const refreshOutstanding = () => {
    getCounterSales(
      { ...payloadGetCounterSales },
      outStandingBills,
      getCounterSalesStatement,
      setNumberOfRecords,
      setOutStandingBills
    );
  };

  useEffect(() => {
    refreshOutstanding();
    // expose globally so addReceipt can call it
    window.refreshOutstandingReport = refreshOutstanding;

    return () => {
      delete window.refreshOutstandingReport; // cleanup
    };
  }, []);

  return (
    <>
      {/* <DynamicBreadcrumbs /> */}
      <Box
        px={2}
        pb={0}
        sx={{
          paddingTop: "15px",
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
        }}
      >
        {businessChooseTab?.value === "outstandingReport" && (
          <Grid container>
            <Heading name="Outstanding Report" />

            {/* <Grid
              item
              xs={12}
              sx={{
                background:
                  "linear-gradient(264deg, rgba(215, 215, 255, 0) 0%, rgba(155, 155, 243, 1) 100%)",
                padding: "10px",
                borderRadius: "5px",
                color: "#01008B",
                textAlign: "left",
                marginBottom: "20px",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                fontWeight: 500,
              }}
            >
              <Typography
                variant="h6"
                fontSize={{ xs: "12px", sm: "13px", md: "15px" }}
              >
                Outstanding Report
              </Typography>
            </Grid> */}

            {businessChooseTab?.value == "outstandingReport" && (
              <React.Fragment>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs={12} sm={12} lg={4}>
                    <TextField
                      fullWidth
                      id="customer-name"
                      label="Search Customer Name / Mobile No."
                      value={search}
                      size="small"
                      onClick={() => setSearchOutStandingsModal(true)}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <SearchIcon
                            onClick={() => setSearchOutStandingsModal(true)}
                            sx={{
                              color: (theme) => theme.palette.primary.main,
                              cursor: "pointer",
                            }}
                          />
                        ),
                        sx: {
                          cursor: "pointer",
                          backgroundColor: "white",
                          borderRadius: "4px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                        },
                      }}
                      InputLabelProps={{
                        shrink: !!search,
                        sx: {
                          fontWeight: 500,
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        },
                      }}
                    />
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    lg={4}
                    sx={{
                      // padding: { sm: "0px 16px" },
                      fontWeight: "bold",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-around",
                      mt: { xs: "1px", sm: "0px" },
                    }}
                  >
                    <FormControl
                      fullWidth
                      sx={{
                        position: "relative",
                        backgroundColor: "white",
                        borderRadius: "4px",
                      }}
                      size="small"
                    >
                      <InputLabel
                        id="demo-simple-select-label"
                        // sx={{ position: "absolute", top: "-6px" }}
                        sx={{
                          color: "#555555",
                          fontWeight: "500",
                          fontSize: { xs: "12px", sm: "13px", md: "15px" },
                        }}
                      >
                        Filter By{" "}
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        size="small"
                        fullWidth
                        value={payloadGetCounterSales.filter}
                        label="Filter By"
                        onChange={(e) => {
                          setSearch("");
                          const updatedPayload = {
                            ...payloadGetCounterSales,
                            filter: e.target.value,
                          };
                          getCounterSales(
                            updatedPayload,
                            outStandingBills,
                            getCounterSalesStatement,
                            setNumberOfRecords,
                            setOutStandingBills,
                          );
                          setPayloadGetCounterSales(updatedPayload);
                        }}
                        sx={{
                          backgroundColor: "white",
                          borderRadius: "4px",
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                        }}
                      >
                        {filters.map((item, index) => (
                          <MenuItem value={item.value} key={"option" + index}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6} lg={4}>
                    <Grid
                      item
                      xs={12}
                      sx={{
                        // padding: { sm: "0px 16px" },
                        // fontWeight: "bold",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-around",
                        mt: { xs: "1px", sm: "0px" },
                      }}
                    >
                      <TextField
                        fullWidth
                        id="Value"
                        label="Amount"
                        size="small"
                        value={payloadGetCounterSales.search}
                        onChange={(e) => {
                          setPayloadGetCounterSales(
                            {
                              ...payloadGetCounterSales,
                              search: e.target.value,
                            },
                            outStandingBills,
                            getCounterSalesStatement,
                            setNumberOfRecords,
                            setOutStandingBills,
                          );
                        }}
                        sx={{
                          "& .MuiOutlinedInput-notchedOutline": {
                            border: "none",
                          },
                          backgroundColor: "white",
                          borderRadius: "4px",
                        }}
                        InputLabelProps={{
                          sx: {
                            borderRadius: "4px",
                            fontWeight: 500,
                            fontSize: { xs: "12px", sm: "13px", md: "15px" },
                            paddingX: "4px",
                          },
                        }}
                        InputProps={{
                          endAdornment: (
                            <SearchIcon
                              onClick={() => {
                                getCounterSales(
                                  {
                                    ...payloadGetCounterSales,
                                    filter: payloadGetCounterSales?.filter,
                                  },
                                  outStandingBills,
                                  getCounterSalesStatement,
                                  setNumberOfRecords,
                                  setOutStandingBills,
                                );
                              }}
                              sx={{
                                color: (theme) => theme.palette.primary.main,
                                cursor: "pointer",
                              }}
                            />
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid
                  container
                  spacing={{ sm: 2, xs: 0 }}
                  sx={{
                    // backgroundColor: "#EAEAFF",
                    padding: "12px 10px",
                    borderRadius: "8px",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    // rowGap: 1,
                  }}
                >
                  <Grid item xs={7} pb={{ xs: 1, sm: 0 }} sm="auto">
                    <Box
                      sx={{
                        backgroundColor: "#CCCCFF",
                        py: "6px",
                        px: { sm: "12px", xs: "8px" },
                        borderRadius: "8px",
                        fontWeight: 500,
                        color: "#00008B",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontWeight: 500,
                          fontSize: { xs: "10px", sm: "13px", md: "15px" },
                        }}
                      >
                        Total Outstanding :&nbsp;&nbsp;&nbsp;
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "10px", sm: "13px", md: "15px" },
                        }}
                      >
                        {search?.trim()?.length > 0
                          ? displayOutstading(outStandingBills, search)
                          : Number(
                              outStandingBills?.totalOustandingAmount || 0,
                            ).toFixed(2)}
                      </Typography>
                    </Box>
                  </Grid>

                  <Grid item xs={4} pb={{ xs: 1, sm: 0 }} sm="auto">
                    <Box
                      sx={{
                        backgroundColor: "#CCCCFF",
                        py: "6px",
                        px: { sm: "10px", xs: "6px" },
                        borderRadius: "8px",
                        fontWeight: 500,
                        color: "#00008B",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <Typography
                        component="span"
                        sx={{
                          fontWeight: 500,
                          fontSize: { xs: "10px", sm: "13px", md: "15px" },
                        }}
                      >
                        Total Bills :&nbsp;&nbsp;&nbsp;
                      </Typography>
                      <Typography
                        component="span"
                        sx={{
                          fontWeight: 600,
                          fontSize: { xs: "10px", sm: "13px", md: "15px" },
                        }}
                      >
                        {outStandingBills?.totalRecords || 0}
                      </Typography>
                    </Box>
                  </Grid>

                  {/* Download Button */}
                  <Grid item xs="auto" sx={{ marginLeft: "auto" }}>
                    <Button
                      variant="contained"
                      fullWidth
                      sx={{
                        height: "40px",
                        backgroundColor: "#14008B",
                        px: 2,
                        fontSize: { xs: "12px", sm: "13px", md: "15px" },
                      }}
                      onClick={() =>
                        downloadXLSXFile(
                          api +
                            "Reports/ReportOutstandingCouterSalesStatementXlsx",
                          {
                            ...payloadGetCounterSales,
                            page: pagination.page,
                            pageSize: pagination.pageSize,
                          },
                        )
                      }
                      endIcon={<DownloadIcon />}
                    >
                      Download
                    </Button>
                  </Grid>
                </Grid>

                <Grid
                  container
                  sx={{
                    p: { xs: "1px", sm: "10px" },
                    mt: 2,
                    background: "white",
                    borderRadius: "12px",
                    overflowX: "auto",
                  }}
                >
                  <Box sx={{ minWidth: "600px", width: "100%" }}>
                    <Grid container>
                      {/* Header */}
                      <Grid item xs={12}>
                        <Grid
                          container
                          sx={{
                            borderBottom: "1.5px solid black",
                            padding: "10px",
                          }}
                        >
                          <Grid item xs={2}>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                textAlign: "center",
                                fontWeight: 500,
                                color: "#01008B",
                              }}
                            >
                              Bill No.
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                textAlign: "center",
                                fontWeight: 500,
                                color: "#01008B",
                              }}
                            >
                              Customer Name
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                textAlign: "center",
                                fontWeight: 500,
                                color: "#01008B",
                              }}
                            >
                              Date
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                textAlign: "center",
                                fontWeight: 500,
                                color: "#01008B",
                              }}
                            >
                              Mobile No.
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                textAlign: "center",
                                fontWeight: 500,
                                color: "#01008B",
                              }}
                            >
                              Days Elapsed
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              sx={{
                                fontSize: {
                                  xs: "12px",
                                  sm: "13px",
                                  md: "15px",
                                },
                                textAlign: "center",
                                fontWeight: 500,
                                color: "#01008B",
                              }}
                            >
                              Total
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>

                      <Grid
                        item
                        xs={12}
                        sx={{
                          height: "60vh",
                          overflowY: "auto",
                          marginTop: "10px",
                          padding: "15px",
                        }}
                      >
                        {outStandingBills?.records
                          ?.filter((ele) => {
                            if (!selectedUser.name || !selectedUser.mobile)
                              return true; // show all if no user selected

                            return (
                              ele?.buyerName?.toLowerCase() ===
                                selectedUser.name?.toLowerCase() &&
                              ele?.buyerMobile === selectedUser.mobile
                            );
                          })
                          .map((ele, index) => {
                            return (
                              <Grid
                                container
                                key={index}
                                onClick={() => {
                                  setModalData(ele);
                                  setOpen(true);
                                }}
                                sx={{
                                  p: "8px 0",
                                  borderBottom: "1px solid #eee",
                                  alignItems: "center",
                                  backgroundColor: "#E8E8FF",
                                  borderRadius: "8px",
                                  mb: 1,
                                  cursor: "pointer",
                                }}
                              >
                                <Grid
                                  item
                                  xs={2}
                                  sx={{ pr: { xs: 5, sm: 4, lg: 10 } }}
                                >
                                  <Typography
                                    sx={{
                                      textAlign: "right",
                                      fontWeight: "500",
                                      fontSize: {
                                        xs: "12px",
                                        sm: "13px",
                                        md: "15px",
                                      },
                                    }}
                                  >
                                    {ele?.billNumber || "-"}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={2}
                                  sx={{ pl: { xs: 2, sm: 2, lg: 4 } }}
                                >
                                  <Typography
                                    sx={{
                                      textAlign: "left",
                                      fontWeight: "500",
                                      fontSize: {
                                        xs: "12px",
                                        sm: "13px",
                                        md: "15px",
                                      },
                                    }}
                                  >
                                    {ele?.buyerName || "-"}
                                  </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                  <Typography
                                    sx={{
                                      textAlign: "center",
                                      fontWeight: "500",
                                      fontSize: {
                                        xs: "12px",
                                        sm: "13px",
                                        md: "15px",
                                      },
                                    }}
                                  >
                                    {convertDateToCustomFormat(
                                      ele?.billDate?.split("T")[0] || "-",
                                    )}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={2}
                                  sx={{ pr: { xs: 1, sm: 1, lg: 6 } }}
                                >
                                  <Typography
                                    sx={{
                                      textAlign: "right",
                                      fontWeight: "500",
                                      fontSize: {
                                        xs: "12px",
                                        sm: "13px",
                                        md: "15px",
                                      },
                                    }}
                                  >
                                    {ele?.buyerMobile || "-"}
                                  </Typography>
                                </Grid>
                                <Grid
                                  item
                                  xs={2}
                                  sx={{ pr: { xs: 1, sm: 1, lg: 5 } }}
                                >
                                  <Typography
                                    sx={{
                                      textAlign: "right",
                                      fontWeight: "500",
                                      fontSize: {
                                        xs: "12px",
                                        sm: "13px",
                                        md: "15px",
                                      },
                                    }}
                                  >
                                    {ele?.daysElapsed || "-"}
                                  </Typography>
                                </Grid>
                                <Grid item xs={2}>
                                  <Box
                                    p={1}
                                    px={{ xs: 2, sm: 2, md: 3, lg: 7 }}
                                  >
                                    <Box
                                      display="flex"
                                      justifyContent="space-between"
                                      alignItems="center"
                                      sx={{
                                        width: "100%",
                                        fontSize: {
                                          xs: "12px",
                                          sm: "13px",
                                          md: "15px",
                                        },
                                      }}
                                    >
                                      <CurrencyRupeeIcon
                                        sx={{
                                          fontSize: "16px",
                                          color: "#000",
                                          fontSize: {
                                            xs: "12px",
                                            sm: "13px",
                                            md: "15px",
                                          },
                                        }}
                                      />
                                      <Typography
                                        fontWeight={500}
                                        align="right"
                                        sx={{
                                          flex: 1,
                                          textAlign: "right",
                                          fontSize: {
                                            xs: "12px",
                                            sm: "13px",
                                            md: "15px",
                                          },
                                        }}
                                      >
                                        {ele?.balanceAmount?.toFixed(2)}
                                      </Typography>
                                    </Box>
                                  </Box>
                                </Grid>
                              </Grid>
                            );
                          })}
                      </Grid>
                    </Grid>
                  </Box>
                </Grid>

                {/* <Grid
                container
                sx={{
                  marginX: "20px",
                }}
              >
                {outStandingBills?.records?.map((item, i) => {
                  console.log("Outstanding item ", item);
                  if (
                    !item?.buyerName?.toLowerCase().includes(search.toLowerCase()) &&
                    !item?.buyerMobile
                      ?.toLowerCase()
                      .includes(search.toLowerCase()) &&
                    search.length > 0
                  ) {
                    return null;
                  }
                  return (
                    <Grid
                      item
                      xs={12}
                      sm={12}
                      md={6}
                      lg={4}
                      key={"payamentRecpt" + i}
                      sx={{ p: "5px", borderRight: "3px solid #dfdfdf" }}
                    >
                      <OutStandingReportCart
                        item={item}
                        setOpen={setOpen}
                        setModalData={setModalData}
                      />
                    </Grid>
                  );
                })}
              </Grid> */}

                <DisplayOutStandingReport
                  modalData={modalData}
                  open={open}
                  setOpen={setOpen}
                  getRecept={() => {
                    // getPaymentRec({ ...getPaymentObj });
                  }}
                />
                {/* -------- */}
                {/* <Grid container sx={{ pt: "10px" }}>
                <Grid item xs={4}></Grid>
                <Grid
                  item
                  xs={4}
                  sx={{
                    // bgcolor: "red",
                    display: "flex",
                    justifyContent: "center",
                  }}
                > */}
                {/* <Stack direction="row" justifyContent="space-around" sx={{ mt: 2 }}> */}
                {/* <Pagination
                    count={
                      Number.isInteger(numberOfRecords / pagination.pageSize)
                        ? numberOfRecords / pagination.pageSize
                        : parseInt(numberOfRecords / pagination.pageSize) + 1
                    }
                    page={pagination.page}
                    onChange={handleChange}
                  /> */}
                {/* </Stack> */}
                {/* </Grid>
                <Grid item xs={4}></Grid>
              </Grid> */}
              </React.Fragment>
            )}

            {/* {businessChooseTab?.value != "outstandingReport" && (
            <PaymentReceipt />
          )} */}
            {/* //------------------------ */}
          </Grid>
        )}
      </Box>

      {businessChooseTab?.value != "outstandingReport" && <PaymentReceipt />}

      <PaymentReceiptSearchModal
        searchModal={searchOutStandingsModal}
        setSelectedUser={setSelectedUser}
        setSearchModal={setSearchOutStandingsModal}
        unPaidBill={unPaidBill}
        getUnpaid={getUnpaid}
        setBillData={setBillData}
        search={search}
        setSearch={setSearch}
        setUnPaidBill={setUnPaidBill}
        setUnPaidBillData={setUnPaidBillData}
        setPagination={setPagination}
        billData={billData}
        callSearchApi={(searchValue) => {
          const isMobile = /^\d{10}$/.test(searchValue); // Check if it's a 10-digit mobile number
          const filterType = isMobile ? "buyermobile" : "buyername";

          setBillFilter("");
          setPayloadGetCounterSales({ ...payloadGetCounterSales, search: "" });

          getCounterSales(
            {
              page: 1,
              pageSize: 10000,
              sortBy: "",
              order: 0,
              buyerGroupId: 0,
              filter: filterType, // <-- dynamic filter
              search: searchValue,
            },
            outStandingBills,
            getCounterSalesStatement,
            setNumberOfRecords,
            setOutStandingBills,
          );
        }}

        //  userDetail={userDetail}
      />
      {/* </Box> */}
      {/* </Drawer> */}
    </>
  );
};

export default OutstandingReport;
